<script lang="ts" setup>
import type { ProductDetailItem, ProductListItem } from "~~/models/products";
import type { CatalogPageRecord, LayoutRecord } from "~~/server/graphql/datocms/generated";

const { product } = defineProps<{
  layout: LayoutRecord;
  cmsData: CatalogPageRecord;
  product: ProductDetailItem;
}>();

const { loggedIn } = useUserSession();

// get related products
const { data: relatedProducts } = await useFetch<Array<ProductListItem>>("/api/ecom/products/related", {
  query: {
    categoryId: product.productGroupCategoryId,
  },
});

const relatedProductsFiltered = computed(() => {
  return relatedProducts.value?.filter(p => p.id !== product?.id).slice(0, 4) ?? [];
});

const { prices, isPricesLoading } = usePricing(relatedProductsFiltered, { loggedIn: loggedIn.value });
</script>

<template>
  <CenterCard v-if="relatedProductsFiltered?.length" view-mode="wide">
    <h3 class="mt-3xl mb-xl md:mb-2xl text-center">
      {{ cmsData.detailTitleRelatedProducts }}
    </h3>

    <div class="gap-xl lg:gap-4xl flex flex-col">
      <div class="gap-xs lg:gap-md grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        <div v-for="relatedProduct of relatedProductsFiltered" :key="relatedProduct.id">
          <ProductCardItem
            :layout="layout"
            :cms-data="cmsData"
            :product="relatedProduct"
            :prices="prices"
            :is-prices-loading="isPricesLoading"
            :overpack-popper="{ placement: 'bottom' }"
          />
        </div>
      </div>
    </div>
  </CenterCard>
</template>

<style scoped>

</style>
